module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 20 18",
      url: __webpack_public_path__ + "img/icons.e66ad95c.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }